import { AxiosHeaders, InternalAxiosRequestConfig } from "axios";
import { getAmplitudeApiHeaders } from "@/services/Amplitude";

export const applyAmplitudeRequestHeaders = (config: InternalAxiosRequestConfig) => {
  const headers = AxiosHeaders.from(config.headers);

  Object.entries(getAmplitudeApiHeaders()).forEach(([name, value]) => {
    headers.set(name, value);
  });

  config.headers = headers;
  return config;
};
